import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { VolumeFan } from '../VolumeFan';
import { BONUS_GROUP } from '../../data/catio';
const MAIN = ['5 Premium Volumes', '40 Ready-to-Build Projects', '200+ Pages'];
const EXTRAS = ['Imperial + Metric', 'Instant Digital Access'];

/**
 * Main product (five volumes) clearly leads; the free bonuses sit beneath it,
 * smaller, as added value — never competing with the collection.
 */
export function ValueStackSection() {
  return <section aria-labelledby="stack-title" className="bg-stone py-12 sm:py-20" data-id="element-307" data-mp="2advkl02mukev">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-308" data-mp="2f77yaf5rx6su">
        <SectionHeading id="stack-title" align="center" title="Everything You Need to Stop Designing and Start Building" data-id="element-309" data-mp="2k4zz5yoec396" />

        <div className="mt-8 sm:mt-12" data-id="element-310" data-mp="2p674lr32gqco">
          <p className="label-tech text-center text-wood" data-id="element-311" data-mp="2t5ob8nu8btjf">The main collection</p>
          <div className="-mx-3 mt-3 sm:mx-auto sm:max-w-2xl" data-id="element-312" data-mp="2t3lgjqi4tc8d">
            <VolumeFan data-id="element-313" data-mp="3hiii5k051p0b" />
          </div>
          <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-314" data-mp="3chuk4edhs7wl">
            {MAIN.map(item => <li key={item} className="flex items-center gap-2 text-[0.98rem] font-semibold text-ink" data-id="element-315" data-mp="37hygwhcmcki3">
                <CheckIcon className="h-4 w-4 shrink-0 text-wood" strokeWidth={2.5} aria-hidden data-id="element-316" data-mp="32kq4kxe5jaor" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="my-8 flex items-center gap-4" aria-hidden data-id="element-317" data-mp="3v7srstddnyzp">
          <span className="h-px flex-1 bg-wood-light/60" data-id="element-318" data-mp="3vaopqhp86no5" />
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-ember bg-paper text-ember" data-id="element-319" data-mp="3qgaxup9ruyo8">
            <PlusIcon className="h-5 w-5" strokeWidth={2} data-id="element-320" data-mp="3lggagvp7gr7x" />
          </span>
          <span className="h-px flex-1 bg-wood-light/60" data-id="element-321" data-mp="mu3m7gfd4msf" />
        </div>

        <div className="mx-auto grid max-w-3xl items-center gap-5 rounded-[16px] border border-line bg-paper p-4 shadow-[0_18px_36px_-30px_rgba(28,31,28,0.35)] sm:grid-cols-[0.9fr_1.1fr] sm:gap-7 sm:p-6" data-id="element-322" data-mp="i1k7gg4xvlm1">
          <img src={BONUS_GROUP.src} alt={BONUS_GROUP.alt} width={BONUS_GROUP.width} height={BONUS_GROUP.height} loading="lazy" decoding="async" className="mx-auto w-[82%] rounded-[10px] sm:w-full" data-id="element-323" data-mp="2h7pkhsg6hm2e" />
          <div className="text-center sm:text-left" data-id="element-324" data-mp="1tiwv6eu2acgr">
            <p className="label-tech inline-flex rounded-full border border-ember px-3 py-1.5 text-ember" data-id="element-325" data-mp="1tlj3whsouy0k">
              Included free
            </p>
            <p className="mt-3 font-display text-[1.5rem] leading-[1.15] text-ink" data-id="element-326" data-mp="1jm0ngbbzlud9">
              5 Practical Bonuses
            </p>
            <ul className="mt-3 grid gap-2" data-id="element-327" data-mp="1okbt09v91ipo">
              {EXTRAS.map(item => <li key={item} className="flex items-center justify-center gap-2 text-[0.95rem] font-medium text-graphite sm:justify-start" data-id="element-328" data-mp="3dzjdl03ouaoj">
                  <CheckIcon className="h-4 w-4 shrink-0 text-wood" strokeWidth={2.5} aria-hidden data-id="element-329" data-mp="17b9arndzjj02" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}